export default __webpack_public_path__ + "static/home_agri-e1bf2fc48d84393ff29aa409399dfebe.jpg";